import { render, staticRenderFns } from "./NoOffer.vue?vue&type=template&id=520645af&"
import script from "./NoOffer.vue?vue&type=script&lang=js&"
export * from "./NoOffer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports